import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
import stringify from 'fast-json-stable-stringify';
import SubscriptionCallToActionComponent
  from '@fuww/library/src/SubscriptionCallToAction';
import messages from '../../lib/messages.mjs';
import LinkAndAnchor from '../LinkAndAnchor';
import { saveRouterState } from '../../lib/routerState';
import createAnalyticsEvent
  from '../../lib/mutations/createAnalyticsEvent.graphql';
import { AnalyticsEventType } from '../../lib/graphql/api/graphql';
import { useSiteContext } from '../SiteContext';
import getArticleSubjectType from '../../lib/getArticleSubjectType';
import { UserContext } from '../UserProvider';

const SubscriptionCallToAction = () => {
  const intl = useIntl();
  const router = useRouter();
  const [createPageview] = useMutation(createAnalyticsEvent);
  const { route, query } = useRouter();
  const { query: { id } } = useRouter();
  const subjectId = id ? `${id}` : null;

  const {
    prefix,
    hasLocalNews,
    url,
    newsboard,
  } = useSiteContext();

  const { user } = useContext(UserContext);

  // eslint-disable-next-line no-underscore-dangle
  const userId = user?._id;

  useEffect(() => {
    createPageview({
      variables: {
        type: AnalyticsEventType.EVENT,
        url,
        title: 'subscription callToAction',
        subjectType: id ? getArticleSubjectType(prefix, hasLocalNews) : null,
        subjectId: subjectId ? `${subjectId}` : null,
        payload: JSON.stringify({
          newsboard,
          userId,
        }),
      },
    });
    // don't re-run it even when data changes
    // only route and query changes should trigger this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringify({ route, query })]);

  return (
    <SubscriptionCallToActionComponent
      callToActionMessage={intl.formatMessage(
        messages['subscriptionCallToAction.callToAction'])}
      saveMessage={intl.formatMessage(
        messages['subscriptionCallToAction.saveMessage'])}
      sellingPoints={[
        intl.formatMessage(
          messages['subscriptionCallToAction.exclusiveAccess'],
        ),
        intl.formatMessage(
          messages['subscriptionCallToAction.insiderForecasts'],
        ),
        intl.formatMessage(
          messages['subscriptionCallToAction.directInsights'],
        ),
      ]}
      youCanCancelMessage={intl.formatMessage(
        messages['subscriptionCallToAction.youCanCancel'],
      )}
      startReadingMessage={intl.formatMessage(
        messages['subscriptionCallToAction.startReading'],
      )}
      complimentaryAccessMessage={intl.formatMessage(
        messages['subscriptionCallToAction.complimentaryAccess'],
      )}
      subscriptionPriceMessage={intl.formatMessage(
        messages['subscriptionCallToAction.subscriptionPrice'],
      )}
      subscriptionBillingPeriodMessage={intl.formatMessage(
        messages['subscriptionCallToAction.subscriptionBillingPeriod'],
      )}
      LinkComponent={LinkAndAnchor}
      onClick={() => {
        saveRouterState(router);
      }}
    />
  );
};

export default SubscriptionCallToAction;
